import api from '../api'

const baseUrl = '/university/api/AdminTeacher'

const moocTeacherProvider = {
  getTeacher(params) {
    return api.get(`${baseUrl}/Get/${params}`)
  },

  addTeacher(params) {
    return api.post(`${baseUrl}/Add`, params)
  },

  updateTeacher(params = {}) {
    return api.put(`${baseUrl}/Edit`, params)
  },

  deleteTeacher(params) {
    return api.delete(`${baseUrl}/Delete/${params}`)
  },

  deleteFacultyTeacher(params) {
    return api.delete(`${baseUrl}/DeleteFacultyTeacher/${params}`)
  },

  searchTeacher(params) {
    return api.post(`${baseUrl}/GetByPhoneNumberAndNationalCode`, params)
  },
}

export default moocTeacherProvider
